import { Shift } from '@nextforce/api'
import { Id } from '@nextforce/api'

export interface CrewRating {
  shiftId: Id
  raterId: Id
  rating: number
}

export interface RatingSubViewProps {
  shift?: Shift
  onPressCloseButton(): void
  onChangeRating(number: any): void
}

export type CrewRatingMap = { [shiftId: string]: CrewRating }

export const DEFAULT_RATING = 3
